import styled from 'styled-components';

import { colors, fonts } from 'shared/defaultTheme';

export const BoxAttachDocument = styled.div`
  box-sizing: border-box;
  height: ${({ height }) => `${height}px`};
  border-radius: 2px;
  background-color: ${colors.white};
  box-shadow: 0 1px 4px 0 ${colors.pattens};
  border: ${({ isDrop }) =>
    isDrop ? `2px dashed ${colors.black} !important` : `1px solid ${colors.pattens}`};
  &:hover {
    border: 2px dashed black !important;
  }
  .drag-drop-notification-drag {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
    text-align: center;
  }
  .explore_computer-container {
    position: relative;
    top: 25px;
  }
`;
